<ion-row *ngIf="!p.renderMobile; else mobileProductsView" class="content border-bottom">
  <ion-col size="1">
    <ion-img
    class="order-details-view__product-image"
    [src]="row.product.image?.filePath ? row.product.image.filePath : '../../../assets/icons/service-plug.svg'"
    >
    </ion-img>  </ion-col>
  <ion-col class="order-details-view__name" size="5">
    {{row.productName }}
  </ion-col>
  <ion-col size="2">
      {{row.amount}}
  </ion-col>
  <ion-col size="2">
    {{row.price | currency: ' '}}  {{'PLN'| translate}}
  </ion-col>
  <ion-col size="2">
    {{row.totalCost | currency: ' '}}  {{'PLN'| translate}}
  </ion-col>
</ion-row>

<ng-template #mobileProductsView>
  <ion-card class="order-details-view">
    <ion-card-content>
      <ion-grid>
        <ion-row>
          <ion-col class="order-details-view__col" size="12">
            <ion-img
            class="order-details-view__product-image"
            [src]="row.product.image?.filePath ? row.product.image.filePath : '../../../assets/icons/service-plug.svg' "
            >
            </ion-img>
            <ion-label class="order-details-view__name">
              {{row.productName }}
            </ion-label>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="order-details-view__col" size="6" >
            <ion-label>
              {{'MARKET.AMOUNT' | translate}}:
            </ion-label>
            <div class="order-details-view__amount">
              {{row.amount}}
            </div>
            <ion-label>
            </ion-label>
          </ion-col>
          <ion-col size="6">
            <table class="order-details-view__price_table">
              <tr>
                <td>
                  <ion-label class="order-details-view__price">
                    {{row.totalCost  | currency: ' '}}  {{'PLN'| translate}}
                  </ion-label>
                </td>
              </tr>
              <tr>
                <td>
                  <ion-label class="order-details-view__for-each">
                    {{row.price | currency: ' '}}  {{'PLN'| translate}} {{'MARKET.FOR_EACH' | translate}}
                  </ion-label>
                </td>
              </tr>
            </table>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-card-content>
  </ion-card>
</ng-template>
